import React from "react";
import "./EAProgressBar.scss";

interface IProps {
  currentStep: number;
  totalSteps: number;
}

const EAProgressBar: React.FC<IProps> = ({ currentStep, totalSteps }) => {
  // Calculate percentage: 33% for step 1, 66% for step 2, 100% for step 3
  const getPercentage = () => {
    if (currentStep === 1) return 33;
    if (currentStep === 2) return 66;
    return 100;
  };

  const percentage = getPercentage();

  return (
    <div className="ea-progress-bar">
      <div className="ea-progress-bar__container">
        <div className="ea-progress-bar__fill" style={{ width: `${percentage}%` }} />
      </div>
    </div>
  );
};

export default EAProgressBar;

